import PropTypes from 'prop-types';
import { BRAND_PROFILES_LIST } from 'constants/index';
import validateADGroupAgainstUserRoles from 'modules/shell/utils/userRoles';

// Available list of roles. It Could be extended in the future
const PROP_TYPE_ROLES_ENUM = [
  'back_of_house',
  'stylist',
  'stylist_manager',
  'store_associate',
  'store_manager',
  'store_general_manager',
  'client_advisor',
  'instore_sales',
];

/**
 * Render children components in case of AD groups of logged in user comply with supplied list of `roles` and `brand` (optional)
 */
const UserRoleSpecificContent = ({ __ADGroup__, roles, children, brand, validationType }) => {
  const userRoles = Array.isArray(roles) ? roles : [roles];

  const isUserEligible = validateADGroupAgainstUserRoles({
    assignedADGroup: __ADGroup__,
    userRoles,
    brand,
    validationType,
  });

  return isUserEligible ? children : null;
};

UserRoleSpecificContent.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),

  roles: PropTypes.oneOfType([
    PropTypes.oneOf(PROP_TYPE_ROLES_ENUM),
    PropTypes.arrayOf((propValue) => {
      if (!Array.isArray(propValue) || !propValue.every((value) => PROP_TYPE_ROLES_ENUM.includes(value))) {
        return new Error('Invalid prop roles supplied to UserRolesContainer. Validation failed.');
      }
    }),
  ]).isRequired,

  brand: PropTypes.oneOf(BRAND_PROFILES_LIST),

  /**
   * Determine the way to validate the supplied user `roles`
   * include - render children components in case of at least some roles items is in users `__ADGroup__`s
   * exclude - render children components in case of all roles items aren't available in users `__ADGroup__`s
   */
  validationType: PropTypes.oneOf(['include', 'exclude']),

  /**
   * The AD group of logged in user. Should be provided by container component only.
   */
  __ADGroup__: PropTypes.string,
};

UserRoleSpecificContent.defaultProps = {
  validationType: 'include',
  __ADGroup__: '',
};

export default UserRoleSpecificContent;
